import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";
import Loader from "components/loader/Loader";
import { helper } from "lib/helper";
import adminModel from "models/admin.model";
import { useEffect, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";

const AddSubCategory = () => {
  const navigate = useNavigate()
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [publishAction, setPublishAction] = useState(false);
  const [categoryType, setCategoryType] = useState("coreActivitiesOptions");
  const [activities, setActivities] = useState("");
  const [activityArray, setActivityArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [expid, setexpid] = useState("");
  const [icon, setIcon] = useState(null);
  const [showIconOption, setShowIconOption] = useState(false);
  const [showTrandingOption, setshowTrandingOption] = useState(false);

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setshowTrandingOption(false);
    setActivityArray([]);
    switch (value) {
      case "experienceCommitmentOptions":
        setShowIconOption(true);
        break;
      case "intendedAudienceOptions":
        setShowIconOption(true);
        break;
      case "trandingCategoryOption":
        setshowTrandingOption(true);
        setShowIconOption(true);
        break;
      default:
        setShowIconOption(false);
        break;
    }

    setCategoryType(e.target.value);
  };

  const handleAddCategory = async (e) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      const fromData = new FormData();
      if (expid) {
        fromData.append("experienceId", expid)
      } else {
        helper.sweetalert.toast("Please fill all the fields!");
        return
      }

      fromData.append("publish", publishAction ? true : false);
      if (showIconOption) {
        if (!categoryName || !icon) {
          helper.sweetalert.toast("Please fill all the fields icon or name missing!");
          return;
        }
        fromData.append("optionName", categoryType);
        fromData.append("optionValue", categoryName);
        fromData.append("image", icon);
      } else {
        if (!activityArray.length) {
          helper.sweetalert.toast("Please Add atlease 1 activity!");
          setIsLoading(false);
          return;
        }
        fromData.append("optionName", categoryType);
        fromData.append("optionValue", JSON.stringify(activityArray));
        console.log(fromData);
      }



      const res = await adminModel.createExperienceOption(fromData);
      if (!res?.success) {
        helper.sweetalert.toast(res.message || "Something went wrong, Please try again later!");
        setIsLoading(false);
        return;
      }
      helper.sweetalert.toast("Sub Category Added successfully!");
      setCategoryName("");
      setIcon(null);
      setCategoryType("coreActivitiesOptions");
      setActivities("");
      setActivityArray([]);
      // console.log(res);
      setIsLoading(false);
      navigate("/admin/experience-categories");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      helper.sweetalert.toast(
        "Something went wrong, Please try again later!",
        "error"
      );
    }
  };

  const handleIconChange = (e) => {
    const selectedFile = e.target.files[0];
    setIcon(selectedFile);
  };

  const updateList = (action, value, index) => {
    if (action === "add") {
      setActivityArray([...activityArray, value]);
    } else {
      const newArray = activityArray.filter((item, i) => i !== index);
      setActivityArray(newArray);
    }
  };

  const getExperienceCategory = async () => {
    setIsLoading(true);
    try {
      const response = await adminModel.getExperienceCategory()
      setCategoriesList(response.data)
      console.log(response);
      setIsLoading(false);
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message || 'Something went wrong', "warning");
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getExperienceCategory()
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Container className="pt-7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add Sub Tags</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleAddCategory}>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="type">Experience Tags</Label>
                        <Input
                          type="select"
                          name="type"
                          id="type"
                          value={expid || ""} // fallback to prevent uncontrolled warning
                          onChange={e => setexpid(e.target.value)}
                          required
                        >
                          <option value="" disabled>Select an option</option>
                          {categoriesList.map((item, i) => (
                            <option key={i} value={item._id}>
                              {item.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="type">Tags Type</Label>
                        <Input
                          type="select"
                          name="type"
                          id="type"
                          defaultValue={"coreActivitiesOptions"}
                          onChange={handleCategoryChange}
                          required
                        >
                          <option value="coreActivitiesOptions">Core Activities</option>
                          <option value="trandingCategoryOption">Tranding category</option>
                          <option value="otherActivityOptions">Additional activities</option>
                          <option value="goodsOrServiceOptions">Services</option>
                          <option value="goods">Goods</option>
                          <option value="intendedAudienceOptions">Intended Audience</option>
                          <option value="experienceEntryOptions">Experience Entry Option</option>
                          <option value="experienceExitOptions">Experience Exit Option</option>
                          <option value="experienceCommitmentOptions">Experience Commitment Option</option>
                          <option value="experienceVibeOptions">Experience Vibe</option>
                          <option value="experienceGiftOptions">Experience Gift</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {!showIconOption && (
                    <FormGroup>
                      <Label for="activities">Activities</Label>
                      <Input
                        type="text"
                        name="activities"
                        id="activities"
                        value={activities}
                        onChange={(e) => setActivities(e.target.value)}
                        placeholder="Add Activities"
                        onClick={(e) => e.preventDefault()}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-success mt-2"
                        onClick={(e) => {
                          e.preventDefault();
                          updateList("add", activities);
                          setActivities("");
                        }}
                      >
                        Add More Activity
                      </button>
                      <div className="mt-2">
                        {activityArray?.map((item, index) => (
                          <span
                            className="badge rounded-pill text-bg-success"
                            key={index}
                          >
                            {item}{" "}
                            <IoCloseSharp
                              size={15}
                              onClick={() => updateList("remove", "", index)}
                            />
                          </span>
                        ))}
                      </div>
                    </FormGroup>
                  )}

                  {showIconOption && (
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label for="categoryName">Category Name</Label>
                          <Input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter category name"
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label for="icon">Icon / Image</Label>
                          <Input
                            type="file"
                            id="icon"
                            onChange={handleIconChange}
                            accept="image/*"
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  {showTrandingOption && (
                    <Row>
                      <Col md="4">
                        <FormGroup check className="d-flex align-items-center">
                          <Input type="checkbox" id="publish" name="publish" onChange={(e) => setPublishAction(e.target.value)} className="me-2" />
                          <Label check htmlFor="publish" className="mb-0">Publish</Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  <div className="d-flex justify-content-between align-items-center">
                    <BackButton />
                    <AddButton title="Add Sub Category" />
                  </div>
                  {/* <Button color="primary" type="submit">
                    Add Category
                  </Button> */}
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddSubCategory;